// extracted by mini-css-extract-plugin
export default {"btn":"DefaultLayout_btn__4M8Tq","fadeIn":"DefaultLayout_fadeIn__uN0fC","btnIcon":"DefaultLayout_btnIcon__UetMX"};